import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {map, catchError} from 'rxjs/operators'


@Injectable({
  providedIn: 'root'
})

export class DataService {

  private baseUrl = environment.apiBaseUrl;
  private cache: any = {};

  constructor(private http: HttpClient, private httpBackend: HttpBackend, private httpClient: HttpClient) {
    this.httpClient = new HttpClient(httpBackend)
  }

  getData(route:any, refresh:any) {
    if (this.dataForRouteIsCached(route, refresh)) {
      return new Observable(observer => {
        observer.next(this.cache[route])
      })
    } else { // no cached data or refresh requested
      return this.http.get<any>(this.baseUrl + route).pipe(map(response => {
        this.cache[route] = response;
        return response;
      }));
    }
  }

postFile(route: any, data: any) {
  return this.http.post(this.baseUrl + route, data, {
    observe: 'response',
    responseType: 'blob' as 'json'
  });
}

  postWithoutInterceptor(route:any) {

  }

  getLookupData(route: string, refresh: boolean): Observable<any> {
    const paramValues = {

    };

    return this.getDataWithParams(route, paramValues, refresh);
  }

  getDataWithParams(route:any, params:any, refresh:any) {
    if (this.dataForRouteIsCached(route, refresh)) {
      return new Observable(observer => {
        observer.next(this.cache[route])
      })
    } else { // no cached data or refresh requested
      return this.http.get<any>(this.baseUrl + route, { params: params }).pipe(map(response => {
        this.cache[route] = response;
        return response;
      }));
    }
  }

  getRecord(route:any) {
    return this.http.get<any>(this.baseUrl + route);
  }

  getRecordWithParams(route:any, params:any) {
    return this.http.get<any>(this.baseUrl + route, { params: params });
  }

  post(route:any, data:any) {
    return this.http.post<any>(this.baseUrl + route, data);
  }

  postWithQueryParms(route:any) {
    return this.http.post<any>(this.baseUrl + route, "");
  }


  put(route:any, data:any) {
    return this.http.put<any>(this.baseUrl + route, data);
  }

  delete(route:any) {
    return this.http.delete(this.baseUrl + route).pipe(map(response => {
      return response;
    }));
  }

  getReport(route:any) {
    return this.http.get(this.baseUrl + route, { responseType: 'blob' });
  }

  getExternalData(route:any) {
    return this.http.get<any>(route).pipe(map(response => {
      return response;
    }));
  }

  dataForRouteIsCached(route:any, refresh:any) {
    return this.cache[route] && (refresh === false || refresh === undefined);
  }

  clearCache() {
    this.cache = {};
  }

  clearRouteCache(route:any) {
    this.cache[route] = null;
  }
}
